import { render, staticRenderFns } from "./ProfileMyProfileEditEmailModal.vue?vue&type=template&id=2947013a&scoped=true&"
import script from "./ProfileMyProfileEditEmailModal.vue?vue&type=script&lang=ts&"
export * from "./ProfileMyProfileEditEmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2947013a",
  null
  
)

export default component.exports